export default __webpack_public_path__ + "static/media/ABChanelCorpo-Light.a3aa9dd1.ttf";